'use client'

import { useEffect } from 'react'

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    console.error(error)
  }, [error])

  return (
    <html>
      <body className="bg-black text-white">
        <div className="min-h-screen flex items-center justify-center px-6">
          <div className="max-w-xl text-center space-y-6">
            <h1 className="text-4xl font-bold">
              Algo salió mal ⚠️
            </h1>

            <p className="text-white/70">
              Estamos trabajando para solucionarlo.
              Si el problema persiste, vuelve más tarde.
            </p>

            <button
              onClick={() => reset()}
              className="px-6 py-3 rounded-xl bg-white text-black font-semibold hover:bg-gray-200 transition"
            >
              Reintentar
            </button>
          </div>
        </div>
      </body>
    </html>
  )
}